function resizeObserverFunctions() {
  // put your functions that needs resize observer here
}

function resizeObserver() {
  const resizeObserver = new ResizeObserver(() =>
    resizeObserverFunctions()
  ).observe($(".smooth-content").get(0));
}

$(document).on("mfr:styles-rendered", resizeObserver).on("shopify:section:load", resizeObserver);